import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import {Clock, MapPin, Phone, Mail, Send} from 'lucide-react';

const Contact = () => {
  return (
    <Layout>
      <div className="bg-black min-h-screen">
        {/* Header */}
        <div className="bg-zinc-900 py-20">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl font-black text-white italic uppercase mb-4">
              CONTACTEZ-<span className="text-nolimit-red">NOUS</span>
            </h1>
            <p className="text-gray-400 text-xl max-w-2xl mx-auto">
              Une question ? Envie de réserver votre séance d'essai ? N'hésitez pas à nous écrire ou à passer nous voir au club.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Form */}
            <div className="bg-zinc-900 p-8 rounded-2xl border border-white/5">
              <h2 className="text-2xl font-bold text-white mb-6">Envoyez-nous un message</h2>
              <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-400 mb-2">Prénom</label>
                    <input 
                      type="text" 
                      className="w-full bg-black border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-nolimit-red focus:ring-1 focus:ring-nolimit-red transition-colors"
                      placeholder="Votre prénom"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-400 mb-2">Nom</label>
                    <input 
                      type="text" 
                      className="w-full bg-black border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-nolimit-red focus:ring-1 focus:ring-nolimit-red transition-colors"
                      placeholder="Votre nom"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Email</label>
                  <input 
                    type="email" 
                    className="w-full bg-black border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-lime-400 focus:ring-1 focus:ring-lime-400 transition-colors"
                    placeholder="votre@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Sujet</label>
                  <select className="w-full bg-black border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-nolimit-red focus:ring-1 focus:ring-nolimit-red transition-colors">
                    <option>Je veux réserver une séance d'essai</option>
                    <option>Question sur les tarifs</option>
                    <option>Question sur le planning</option>
                    <option>Autre demande</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-2">Message</label>
                  <textarea 
                    rows={4}
                    className="w-full bg-black border border-zinc-800 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-nolimit-red focus:ring-1 focus:ring-nolimit-red transition-colors"
                    placeholder="Votre message..."
                  />
                </div>

                <Button type="submit" className="w-full">
                  Envoyer le message <Send className="ml-2 h-4 w-4" />
                </Button>
              </form>
            </div>

            {/* Info & Map */}
            <div className="space-y-8">
              {/* Info Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-zinc-900 p-6 rounded-xl border border-white/5">
                  <MapPin className="h-8 w-8 text-nolimit-red mb-4" />
                  <h3 className="text-lg font-bold text-white mb-2">Adresse</h3>
                  <p className="text-gray-400 text-sm">
                    155 Rue Robert Schumann<br />
                    54200 Écrouves (Toul)
                  </p>
                </div>
                <div className="bg-zinc-900 p-6 rounded-xl border border-white/5">
                  <Phone className="h-8 w-8 text-nolimit-red mb-4" />
                  <h3 className="text-lg font-bold text-white mb-2">Téléphone</h3>
                  <p className="text-gray-400 text-sm">
                    03 83 64 00 00<br />
                    <span className="text-xs text-zinc-500">Appel non surtaxé</span>
                  </p>
                </div>
                <div className="bg-zinc-900 p-6 rounded-xl border border-white/5">
                  <Mail className="h-8 w-8 text-nolimit-red mb-4" />
                  <h3 className="text-lg font-bold text-white mb-2">Email</h3>
                  <p className="text-gray-400 text-sm">
                    contact@nolimit-fitness.fr<br />
                    <span className="text-xs text-zinc-500">Réponse sous 24h</span>
                  </p>
                </div>
                <div className="bg-zinc-900 p-6 rounded-xl border border-white/5">
                  <Clock className="h-8 w-8 text-nolimit-red mb-4" />
                  <h3 className="text-lg font-bold text-white mb-2">Horaires</h3>
                  <p className="text-gray-400 text-sm">
                    Lundi - Dimanche<br />
                    06h00 - 23h00
                  </p>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-zinc-800 w-full h-64 rounded-2xl overflow-hidden relative">
                <div className="absolute inset-0 flex items-center justify-center bg-zinc-900">
                  <p className="text-gray-500">Carte Google Maps intégrée ici</p>
                </div>
                {/* In a real app, embed Google Maps iframe here */}
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2639.586346772064!2d5.868086315871063!3d48.67951097927043!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4794980e0a3a0a0b%3A0x40a5fb99a3b45b0!2s155%20Rue%20Robert%20Schuman%2C%2054200%20%C3%89crouves!5e0!3m2!1sfr!2sfr!4v1625581234567!5m2!1sfr!2sfr" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0, filter: 'grayscale(100%) invert(92%) contrast(83%)' }} 
                  allowFullScreen 
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
